var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var TorsoEvents = require('backbone-torso/modules/Events');
var settingsViewTemplate = require('./patientSettingsViewTemplate.hbs');
var patientSettingsService = require('./patientSettingsService');
var AccordionFormWidget = require('./../widget/accordion/AccordionFormWidget');
var patientSettingsUsernameAccordionFormTemplate = require('./patientSettingsUsernameAccordionFormTemplate.hbs');
var PatientSettingsPasswordAccordionFormView = require('./PatientSettingsPasswordAccordionFormView');
var PatientSettingsSecurityQuestionsAccordionFormView = require('./PatientSettingsSecurityQuestionsAccordionFormView');

/**
 * View for Patient Portal Settings
 *
 * @class PatientSettingsView
 */
module.exports = TorsoView.extend({
  tagName: 'main',
  className: 'brec-main',
  template: settingsViewTemplate,

  events: {
    'click [data-toggle-all-accordions]': '_toggleAllAccordions',
  },

  injectionSites: {
    'username-accordion': '_usernameAccordion',
    'password-accordion': '_passwordAccordion',
    'security-questions-accordion': '_securityQuestionsAccordion'
  },

  /**
   * @method initialize
   * @override
   * @param options {Object}
   *   @param options.patientVecnaId {String} the vecna id of the patient to render the data for.
   */
  initialize: function(options) {
    this.currentPortalUserModel = patientSettingsService.fetchCurrentPortalUserModel();
    this._usernameAccordion = new AccordionFormWidget({
      model: this.currentPortalUserModel,
      template: patientSettingsUsernameAccordionFormTemplate,
      accordionContentViewId: 'username-accordion',
      accordionTriggerMessageKey: 'patient.settings.username.accordion.trigger.header',
    });

    var view = this;
    this.listenTo(this.currentPortalUserModel, 'change', function(){
      view._usernameAccordion.set('showAccordionContent', true);
    });

    var patientVecnaId = options.patientVecnaId;
    this._passwordAccordion = new PatientSettingsPasswordAccordionFormView({
      accordionContentViewId: 'password-accordion',
      accordionTriggerMessageKey: 'patient.settings.password.accordion.trigger.header',
      patientVecnaId: patientVecnaId
    });
    this._securityQuestionsAccordion = new PatientSettingsSecurityQuestionsAccordionFormView({
      accordionContentViewId: 'security-questions-accordion',
      accordionTriggerMessageKey: 'patient.settings.securityQuestions.accordion.trigger.header',
      patientVecnaId: patientVecnaId
    });

    this.on('change:allAccordionsClosed', this.render);
    this.listenTo(TorsoEvents, 'accordion:showAccordionContentChanged', this._checkAccordionStatus);
  },

  /**
   * @method postrender
   * @override
   */
  postrender: function() {
    this._checkAccordionStatus();
  },

  /**
   * Check if all the accordions are expanded
   * @method _checkAccordionStatus
   * @override
   */
  _checkAccordionStatus: function() {
    var accordions = _.filter(this.__childViews, function(childView) {
      var isAccordion = _.has(childView, 'accordionContentViewId');
      if (isAccordion) {
        return childView;
      }
    });

    var allAccordionsClosed = _.every(accordions, function(accordion) {
      return accordion.viewState.get('showAccordionContent') === false;
    });

    this.set('allAccordionsClosed', allAccordionsClosed);

    return allAccordionsClosed;
  },

  /**
   * @method _toggleAllAccordions
   * @private
   */
  _toggleAllAccordions: function() {
    var accordions = _.filter(this.__childViews, function(childView) {
      var isAccordion = _.has(childView, 'accordionContentViewId');
      if (isAccordion) {
        return childView;
      }
    });

    var shouldOpenAccordion = this._checkAccordionStatus();

    _.each(accordions, function(accordion) {
      accordion.viewState.set('showAccordionContent', shouldOpenAccordion);
    });

    this.set('allAccordionsClosed', !shouldOpenAccordion);
  }
});
